export const getRceTranslations = state => state.rceTranslations;
